"use client";

import PopularListItemCard from "@/components/featured/common/cards/PopularListItemCard";
import PopularRouteImageCard from "@/components/featured/common/cards/PopularRouteImageCard";
import RouteCard from "@/components/pages/bus/cards/RouteCard.jsx";

import {
  AppBanner,
  BenefitCard,
  BlogCard,
  BrandCard,
  CampaignCard,
  PopularLocationCard,
  RegisterBanner,
} from "@/components/featured/common";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import FerryPopularLocations from "@/components/pages/ferry/FerryPopularLocations";

export const componentRegistry = {
  // OpportunitiesCard,
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularRouteImageCard,
  PopularLocationCard,
  PopularListItemCard,
  BenefitCard,
  BrandCard,
  BlogCard,
  AppBanner,
  RegisterBanner,
  RouteCard,
  FerryPopularLocations,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "item",
  // OpportunitiesCard: "item",
  CampaignCard: "item",
  PopularFlightTicketCard: "item",
  PopularLocationCard: "item",
  PopularListItemCard: "item",
  BenefitCard: "item",
  BrandCard: "brand",
  BlogCard: "post",
  RouteCard: "item",
};
